module.exports = __webpack_public_path__ + "img/icon_office.38240f09.png";